import TableComponent from '../../../../../components/stories/organisms/table'
import { PlanMenuTablePaginationContainer } from '../../../styled-component'

const PlanMenuTablePagination = ({ pagination, rowSelection }) => {
  if (!pagination?.totalElements) return null

  const selectedCount =
    Object.values(rowSelection ?? {}).filter(Boolean).length || null

  return (
    <PlanMenuTablePaginationContainer>
      <TableComponent.Pagination
        pagination={pagination}
        selectedItems={selectedCount}
      />
    </PlanMenuTablePaginationContainer>
  )
}

export default PlanMenuTablePagination
